const API_BASE_URL = 'https://tll.architechlab.org/api';

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

export class ApiService {
  private static async request<T>(endpoint: string, options?: RequestInit): Promise<ApiResponse<T>> {
    try {
      console.log(`Making API request to: ${API_BASE_URL}${endpoint}`);
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        headers: {
          'Content-Type': 'application/json',
          ...options?.headers,
        },
        ...options,
      });

      console.log(`API response status: ${response.status}`);
      const data = await response.json();
      console.log(`API response data:`, data);
      return data;
    } catch (error) {
      console.error('API request failed:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Network error',
      };
    }
  }

  // Get all predictions
  static async getPredictions(): Promise<ApiResponse<any[]>> {
    return this.request<any[]>('/predictions');
  }

  // Get predictions by TGE
  static async getPredictionsByTGE(tgeId: string): Promise<ApiResponse<any[]>> {
    return this.request<any[]>(`/predictions/tge/${tgeId}`);
  }

  // Get predictions by team member
  static async getPredictionsByMember(memberId: string): Promise<ApiResponse<any[]>> {
    return this.request<any[]>(`/predictions/member/${memberId}`);
  }

  // Create new prediction
  static async createPrediction(prediction: {
    tgeId: string;
    teamMemberId: string;
    predictedFDV: number;
    chipsBet: number;
  }): Promise<ApiResponse<any>> {
    return this.request<any>('/predictions', {
      method: 'POST',
      body: JSON.stringify(prediction),
    });
  }

  // Get team members with stats
  static async getTeamMembers(): Promise<ApiResponse<any[]>> {
    return this.request<any[]>('/team-members');
  }

  // Get team member by email
  static async getTeamMemberByEmail(email: string): Promise<ApiResponse<any>> {
    return this.request<any>(`/team-members/email/${email}`);
  }

  // Get TGEs with stats
  static async getTGEs(): Promise<ApiResponse<any[]>> {
    return this.request<any[]>('/tges');
  }

  // Settle TGE (admin only)
  static async settleTGE(tgeId: string, actualFDV: number): Promise<ApiResponse<any>> {
    return this.request<any>('/settlements', {
      method: 'POST',
      body: JSON.stringify({ tgeId, actualFDV }),
    });
  }
} 